import clsx from 'clsx';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types.js';

export interface UNSTABLE_AppShellProps extends CommonProps {
  children: ReactNode;
}

export function UNSTABLE_AppShell({ children, UNSAFE_className, UNSAFE_style, ...props }: UNSTABLE_AppShellProps) {
  return (
    <div className={clsx('cim-app-shell', UNSAFE_className)} style={UNSAFE_style} {...props}>
      {children}
    </div>
  );
}

export interface UNSTABLE_AppShellBodyProps extends CommonProps {
  children: ReactNode;
}

export function UNSTABLE_AppShellBody({
  children,
  UNSAFE_className,
  UNSAFE_style,
  ...props
}: UNSTABLE_AppShellBodyProps) {
  return (
    <div className={clsx('cim-app-shell-body', UNSAFE_className)} style={UNSAFE_style} {...props}>
      {children}
    </div>
  );
}
